<template>
    <div class="bg-white">
        <Head>
            <title>Озера</title>
        </Head>
        <Header :pageName="lake.name" :cartCount="cartCount"/>
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8 relative">

            <div class="mb-4">
                <div class="flex page-title-wrp">
                    <h2 class="page-title">
                        <Link class="text-sky-600" :href="$route('index')">Озера /&nbsp;</Link>
                    </h2>
                    <h2 class="page-title"> {{ lake.name }} місця, вільні на {{ form.date }}</h2>
                </div>
            </div>
            <div class="grid grid-flow-row-dense grid-cols-3 points-main-wrapper">
                <div class="col-span-2 mr-4 points-items">
                    <div v-if="!checkIfNoPointsAvailable && !checkIfFishingWithoutPointsAvailable">
                        <p class="text-xl">Наразі немає вільних місць для рибалки на цю дату.</p>
                        <p class="text-xl">Будь-ласка, оберіть іншу дату.</p>
                    </div>
                    <div v-else>
                        <a
                            v-for="fishing_without_point_type in fishing_without_point_types"
                            href="javascript:void(0);"
                            class="mb-4 px-4 py-2 group block point-item-inner-wrapper"
                        >
                            <div class="grid grid-cols-3 py-3 point-item-grid-wrapper">
                                <div>
                                    <div
                                        class="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-sm bg-gray-200 xl:aspect-h-8 xl:aspect-w-7"
                                    >
                                        <img :src="pointImage(fishing_without_point_type)"
                                             alt="Tall slender porcelain bottle with natural clay textured body and cork stopper."
                                             class="h-full w-full object-cover object-center group-hover:opacity-75">
                                    </div>
                                </div>
                                <div class="point-item-description col-span-2 lg:pl-5">
                                    <div class="grid grid-cols-2">
                                        <div>
                                            <h3 class="text-2xl text-gray-900">
                                                {{ fishing_without_point_type.name }}
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="py-1">
                                        <p class="text-sm text-gray-700">
                                            {{ fishing_without_point_type.short_description }}
                                        </p>
                                    </div>
                                    <div class="calendar-inner-date-order-wrapper mt-3 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                                        <ul class="flex items-center">
                                            <li class="py-0 text-sm font-bold">Ціна: </li>
                                            <li class="py-0 ml-1">{{ fishing_without_point_type.price }} грн</li>
                                        </ul>
                                        <loading-button
                                            class="h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center"
                                            @click.prevent="showBookingModal(fishing_without_point_type)">
                                            Забронювати
                                        </loading-button>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <Link
                            :href="$route('index.point.view', {'lake': lake.id, 'point': point.id, 'date': form.date})"
                            class="mb-4 px-4 py-2 group block point-item-inner-wrapper" v-for="point in points">
                            <div class="grid grid-cols-3 py-3 point-item-grid-wrapper">
                                <div>
                                    <div
                                        class="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-sm bg-gray-200 xl:aspect-h-8 xl:aspect-w-7"
                                    >
                                        <img :src="pointImage(point)"
                                             alt="Tall slender porcelain bottle with natural clay textured body and cork stopper."
                                             class="h-full w-full object-cover object-center group-hover:opacity-75">
                                    </div>
                                </div>
                                <div class="point-item-description col-span-2 lg:pl-5">
                                    <div class="grid grid-cols-2">
                                        <div>
                                            <h3 class="text-2xl text-gray-900">{{ point.name }}</h3>
                                        </div>
                                        <div class="flex justify-end">
                                            <button @click.prevent="selectLake(point)" class="map-icon"/>
                                        </div>
                                    </div>
                                    <div class="py-1">
                                        <p class="text-sm text-gray-700">{{ point.short_description }}</p>
                                    </div>
                                    <div class="py-1">
                                        <ul class="flex flex-column justify-start mt-3">
                                            <li class="py-0 text-sm font-bold">Ціна: </li>
                                            <li class="py-0 ml-1">від {{point.price}} грн</li>
                                        </ul>
                                    </div>
                                    <div class="grid grid-cols-2 calendar-inner-date-order-wrapper">
                                        <div class="point-item-availability">
                                            <ul class="flex flex-column justify-start mt-3">
                                                <li class="py-0 text-sm font-bold">Наявний час:</li>
                                                <li v-for="type in availableTypesForPoint(point)" class="py-0 ml-6"
                                                    :class="type.icon"/>
                                            </ul>
                                        </div>
                                        <div class="flex items-center justify-end">
                                            <loading-button
                                                class="h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center"
                                                @click.prevent="showBookingModal(point)">
                                                Забронювати
                                            </loading-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div v-html="lake.description" />
                </div>
                <div class="points-calendar">
                    <Calendar
                        :calendarData="calendarData"
                        :currentDateData="currentDateData"
                        :default-disabled-days="disabledDays"
                        :default-day="form.date"
                        @selectDate="filterPoints"
                        @setDate="setDate"
                    />
<!--                    <div class="flex items-center justify-end mt-4">-->
<!--                        <button-->
<!--                            role="button"-->
<!--                            class="h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center"-->
<!--                            @click.prevent="showMapModalMultiple"-->
<!--                        >-->
<!--                            Переглянути на мапі-->
<!--                        </button>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
        <MapModal
            v-if="showMapModal"
            :show="showMapModal"
            :selected-lake="lake"
            :selectedPoint="selectedPoint"
            :points="modalPoints"
            :multiple-points="multiplePoints"
            :types="types"
            :map-key="mapKey"
            :date="form.date"
            @update:show="closeModal"
        />
        <PointsBookingModal
            :is-quantity-available="isQuantityAvailable"
            :show="showModal"
            :selectedPoint="selectedPoint"
            :types="availableTypes"
            :categories="categories"
            :date="modalDate"
            @update:show="showModal = $event"
            @updateCartCount="cartCount = $event"
        />
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import {Link} from '@inertiajs/inertia-vue3';
import Header from "@/Component/Header"
import LoadingButton from "@/Shared/LoadingButton"
import Calendar from "@/Component/Calendar"
import throttle from "lodash/throttle"
import pickBy from "lodash/pickBy"
import PointsBookingModal from "@/Component/PointsBookingModal"
import MapModal from "@/Component/MapModal.vue";

export default {
    components: {
        MapModal,
        PointsBookingModal,
        LoadingButton,
        Header,
        Link,
        Head,
        Calendar,
    },
    props: {
        points: Object,
        fishing_without_point_types: Array,
        types: Array,
        categories: Array,
        lake: Object,
        disabledDays: Object,
        calendarData: Object,
        filters: Object,
        currentDateData: Object,
        selectedDate: String,
        cartCount: {
            type: Number,
            default: 0
        },
        mapKey: String
    },
    data() {
        return {
            multiplePoints: false,
            showModal: false,
            showMapModal: false,
            selectedPoint: {},
            form: {
                date: this.filters.date ?? this.selectedDate,
                month: this.filters.month,
                year: this.filters.year,
            },
            cartItemsCount: this.cartCount
        };
    },
    computed: {
        isQuantityAvailable() {
            return !!this.lake.price_depend_on_people_count
        },
        modalPoints() {
            return Array.isArray(this.points) ? this.points : Object.values(this.points)
        },
        checkIfNoPointsAvailable() {
            const pointsArray = Array.isArray(this.points) ? this.points : Object.values(this.points)
            return pointsArray.length
        },
        checkIfFishingWithoutPointsAvailable() {
            const fishingWithoutPointTypesArray = Array.isArray(this.fishing_without_point_types) ? this.fishing_without_point_types : Object.values(this.fishing_without_point_types)
            return fishingWithoutPointTypesArray.length
        },
        modalDate() {
            return [this.form.date, this.form.date]
        },
        availableTypes() {
            if (!this.selectedPoint.booked_types || this.selectedPoint.booked_types.length === 0) {
                return this.types;
            }
            const bookedTypeIds = new Set(this.selectedPoint.booked_types.map(bookedType => bookedType.id));
            return this.types.filter(type => !bookedTypeIds.has(type.id));
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.$route('index.points', this.lake.id), pickBy(this.form), {preserveState: true})
            }, 150),
        },
        filters(newValue) {
            this.filterPoints(newValue.date)
        }
    },
    methods: {
        pointImage(point) {
            return point.images ? `/storage/${point.images}` : '/images/default_fishing.jpg'
        },
        availableTypesForPoint(point) {
            if (!point.booked_types || point.booked_types.length === 0) {
                return this.types
            }
            const bookedTypeIds = new Set(point.booked_types.map(bookedType => bookedType.id))
            return this.types.filter(type => !bookedTypeIds.has(type.id))
        },
        showBookingModal(point) {
            this.selectedPoint = point
            this.selectedPoint.lake_name = this.lake.name
            this.showModal = true
        },
        filterPoints(date) {
            this.form.date = date
        },
        setDate(dateData) {
            this.form.month = dateData.month
            this.form.year = dateData.year
            this.form.date = `${dateData.year}-${dateData.month}-1`
        },
        selectLake(point) {
            this.multiplePoints = false
            this.selectedPoint = point
            this.showMapModal = !this.showMapModal
        },
        showMapModalMultiple() {
            this.multiplePoints = true
            this.showMapModal = true
        },
        closeModal($event) {
            this.showMapModal = $event
            this.multiplePoints = false
        }
    }
}
</script>
